import CalendarIcon from "@/assets/icons/limite-calendar.svg?react";
import {
  CONFLITOS_JUSTIFICATIVA_PLACEHOLDER,
  CONFLITOS_SUBTITLE,
  CONFLITOS_TITLE,
  NOVA_ALOCACAO_LABEL,
  OBRA_ATUAL_LABEL,
} from "../equipe-obra.constants";
import { VerificacaoDialog } from "../verificacao-dialog";
import { EquipeAviso } from "../equipe-aviso";
import styles from "../verificacao-dialog/verificacao-conteudo.module.scss";
import type {
  ConflitosAlocacaoDialogProps,
  ConflitosAlocacaoDialogViewModel,
} from "./types-conflitos-alocacao-dialog";

/**
 * Modal "Conflitos de alocação identificados" (HU 2059/2530, Figma 12227:420479): todos os profissionais
 * em conflito numa só etapa, com papel, obra atual, nova alocação e o trecho coincidente. Confirmar
 * exige justificativa e não altera as alocações existentes.
 */
export function ConflitosAlocacaoDialogView({
  maxJustificativa,
  onVoltar,
  onConfirmar,
  grupos,
  ciencia,
}: ConflitosAlocacaoDialogProps & ConflitosAlocacaoDialogViewModel) {
  return (
    <VerificacaoDialog
      testId="conflitos-alocacao"
      title={CONFLITOS_TITLE}
      subtitle={CONFLITOS_SUBTITLE}
      justificativaPlaceholder={CONFLITOS_JUSTIFICATIVA_PLACEHOLDER}
      linhas={1}
      maxLength={maxJustificativa}
      rodapeLargo
      onVoltar={onVoltar}
      onConfirmar={onConfirmar}
    >
      <ul className={`${styles.lista} ${styles.listaConflitos}`}>
        {grupos.map((grupo) => (
          <li key={grupo.usuarioId} className={styles.item} data-testid={grupo.testId}>
            <p className={styles.intro}>
              {grupo.intro.antes}
              <strong>{grupo.nome}</strong>
              {grupo.intro.depois}
            </p>
            {grupo.conflitos.map((conflito) => (
              <div
                key={conflito.chave}
                className={styles.conflito}
                data-testid="conflitos-alocacao-conflito"
              >
                <div className={styles.cards}>
                  <div className={styles.card}>
                    <span className={styles.cardLabel}>
                      <CalendarIcon aria-hidden />
                      {OBRA_ATUAL_LABEL}
                    </span>
                    <span className={styles.cardValor}>{conflito.obraAtual}</span>
                    <span className={`${styles.cardValor} ${styles.cardValorPerigo}`}>
                      {conflito.periodoAtual}
                    </span>
                  </div>
                  <div className={styles.card}>
                    <span className={styles.cardLabel}>
                      <CalendarIcon aria-hidden />
                      {NOVA_ALOCACAO_LABEL}
                    </span>
                    <span className={styles.cardValor}>{conflito.obraNova}</span>
                    <span className={styles.cardValor}>{conflito.periodoNovo}</span>
                  </div>
                </div>
                <EquipeAviso severity="warn" role="status">
                  {conflito.coincidencia}
                </EquipeAviso>
              </div>
            ))}
          </li>
        ))}
      </ul>

      <p className={styles.ciencia}>{ciencia}</p>
    </VerificacaoDialog>
  );
}
